import React from "react";

const LoadingScreen = () => {
    return (
        <div className="fixed left-0 right-0 top-0 bottom-0 bg-[#141414] z-[999999]">
            <div className="relative flex flex-col justify-center items-center w-full h-full">
                <img className="w-[10rem]" src="/assets/logos/logo.svg" alt="loading-logo" />

                <div className="relative mt-4 w-[10rem] h-1 bg-white">
                    <div className="absolute top-0 w-[50%] h-1 bg-primary wider-animation" />
                </div>

                <div className="absolute right-0 top-0 -translate-x-1/2">
                    <div className="right-0 mt-6 flex items-center space-x-4 w-full max-w-[380px] lg:max-w-[350px] relative after:content-[''] after:w-[360px]  after:h-[360px] after:left-[50%] after:translate-x-[-50%] after:bottom-[100%] after:blur-[250px] after:bg-primary after:rounded-full after:absolute after:z-[-1]">
                    </div>
                </div>

                <div className="absolute left-[25%] top-[70%]">
                    <div className="right-0 mt-6 flex items-center space-x-4 w-full max-w-[380px] lg:max-w-[350px] relative after:content-[''] after:w-[360px]  after:h-[360px] after:left-[50%] after:translate-x-[-50%] after:bottom-[100%] after:blur-[250px] after:bg-primary after:rounded-full after:absolute after:z-[-1]">
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoadingScreen